import { useQuery } from "@tanstack/react-query";
import { api, type CaseDetail } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function useCaseDetail(caseId: string) {
  const auth = useAuth();
  return useQuery({
    queryKey: ["case", caseId],
    queryFn: () => api.getCase(caseId),
    enabled: auth.status === "authed" && Boolean(caseId),
  });
}

export function caseTitle(detail: CaseDetail | undefined): string {
  if (!detail) return "";
  return detail.case.title || detail.case.id;
}

export function publishedVersionIds(
  detail: CaseDetail | undefined,
): Set<string> {
  const set = new Set<string>();
  if (!detail) return set;
  for (const locale of detail.locales) {
    if (locale.publishedVersionId) set.add(locale.publishedVersionId);
  }
  return set;
}
